export default __webpack_public_path__ + "static/media/finalbanner.5fd826c3.jpg";